import React from 'react';
import ConfirmDeleteDrawer from 'src/components/20-helper-views/bottom-drawer/common-drawers/ConfirmDelete';
import { bottomDrawerHelperActions } from 'src/components/20-helper-views/bottom-drawer/useBottomDrawer';
import useI18n from 'src/modules/translations/hooks/useI18n';
const DeleteNoteTabDrawer = ({ onDelete, onCancel, }) => {
    const { translate } = useI18n();
    const handleDelete = () => {
        onDelete();
        bottomDrawerHelperActions.hide();
    };
    const handleCancel = () => {
        bottomDrawerHelperActions.hide();
        onCancel?.();
    };
    return (React.createElement(ConfirmDeleteDrawer, { title: translate('Delete Tab'), msg: translate('Are you sure you want to delete this tab? This action cannot be undone.'), onDelete: handleDelete, onCancel: handleCancel }));
};
export default DeleteNoteTabDrawer;
